/* vitaalgae-dt-id-persist.js (END-TO-END / PER-TAB) — VERSION CORRIGÉE LOCALE
   Objectif:
   - Capturer dt_id depuis l'URL si présent
   - Le stocker en sessionStorage (par onglet)
   - L'ajouter aux liens/boutons checkout au moment du clic
   - Ne touche pas aux URLs visibles (pas de replaceState)

   Fix important:
   - Quand on force la navigation checkout (bouton submit), utiliser un checkout URL
     "locale-aware" via Shopify.routes.root (ex: /de/checkout) pour éviter retour en FR.
*/

(function () {
  try {
    var KEY = "vitaalgae_dt_id"; // sessionStorage only (per-tab)

    // Locale prefix (ex: "/" ou "/de/")
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    var PREFIX = ROOT.replace(/\/$/, ""); // "/" -> "" ; "/de/" -> "/de"

    function safeStr(v) {
      return (typeof v === "string" && v.trim()) ? v.trim() : "";
    }

    function getDtIdFromUrl(urlStr) {
      try {
        var u = new URL(urlStr, window.location.origin);
        return safeStr(u.searchParams.get("dt_id") || "");
      } catch (e) {
        return "";
      }
    }

    function ssGet(k) {
      try { return safeStr(sessionStorage.getItem(k) || ""); } catch (e) { return ""; }
    }

    function ssSet(k, v) {
      try { sessionStorage.setItem(k, v); } catch (e) {}
    }

    // 1) Capture depuis l'URL courante
    var fromUrl = getDtIdFromUrl(window.location.href);
    if (fromUrl) ssSet(KEY, fromUrl);

    // 2) Récupère dt_id stocké
    function getStoredDtId() {
      return ssGet(KEY);
    }

    function addDtIdToHref(href, dtId) {
      if (!dtId) return href;
      try {
        var u = new URL(href, window.location.origin);
        u.searchParams.set("dt_id", dtId);
        return u.toString();
      } catch (e) {
        // fallback simple
        if (!href) return href;
        if (href.indexOf("dt_id=") !== -1) return href;
        return href + (href.indexOf("?") === -1 ? "?" : "&") + "dt_id=" + encodeURIComponent(dtId);
      }
    }

    function isCheckoutHref(href) {
      href = safeStr(href || "");
      if (!href) return false;

      // /checkout ou /checkouts/... ou /cart/checkout
      if (href === "/checkout") return true;
      if (href.indexOf("/checkout") !== -1) return true;
      if (href.indexOf("/checkouts/") !== -1) return true;
      if (href.indexOf("/cart") !== -1 && href.indexOf("checkout") !== -1) return true;

      return false;
    }

    function patchCheckoutLinks() {
      var dtId = getStoredDtId();
      if (!dtId) return;

      var links = document.querySelectorAll("a[href]");
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        var href = a.getAttribute("href") || "";

        // ignore ancres, mailto, tel, js
        if (!href || href[0] === "#") continue;
        if (/^(mailto:|tel:|javascript:)/i.test(href)) continue;

        if (!isCheckoutHref(href)) continue;

        var newHref = addDtIdToHref(href, dtId);
        if (newHref !== href) a.setAttribute("href", newHref);
      }
    }

    function bindCheckoutButtons() {
      var dtId = getStoredDtId();
      if (!dtId) return;

      // Couvre: Dawn cart page + drawer + thèmes divers
      var nodes = Array.prototype.slice.call(document.querySelectorAll(
        'button[name="checkout"], input[name="checkout"], [data-checkout], a[href*="checkout"], a[href="/checkout"]'
      ));

      nodes.forEach(function (el) {
        if (!el || el.__vitaalgae_dt_bound__) return;
        el.__vitaalgae_dt_bound__ = true;

        el.addEventListener("click", function (e) {
          var dt = getStoredDtId();
          if (!dt) return;

          // Si c'est un lien, on patch le href (navigation normale)
          if (el.tagName && el.tagName.toLowerCase() === "a") {
            var href = safeStr(el.getAttribute("href") || "");
            if (href && isCheckoutHref(href)) {
              el.setAttribute("href", addDtIdToHref(href, dt));
            }
            return;
          }

          // Si c'est un bouton checkout (submit), on force une navigation propre
          // IMPORTANT: utiliser checkout locale-aware (ex: /de/checkout) pour garder la langue
          try {
            e.preventDefault();
            e.stopPropagation();
          } catch (err) {}

          var checkoutPath = PREFIX + "/checkout"; // ex: "/de/checkout" ou "/checkout"
          var target = addDtIdToHref(checkoutPath, dt);
          window.location.href = target;
        }, true);
      });
    }

    function apply() {
      patchCheckoutLinks();
      bindCheckoutButtons();
    }

    // Run
    apply();
    document.addEventListener("DOMContentLoaded", apply);

    // Observer (cart drawer / rerenders)
    try {
      var start = Date.now();
      var obs = new MutationObserver(function () {
        // éviter observer infini
        if (Date.now() - start > 8000) {
          try { obs.disconnect(); } catch (e) {}
          return;
        }
        apply();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  } catch (e) {
    // silence volontaire
  }
})();